/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-09 09:33:33
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-11-09 09:34:32
 * @FilePath: /wemeet-web-activity/src/pages/myticket/hooks/usePrice.ts
 * @Description: 价格逻辑处理
 */
import { useMemo } from 'react';
const usePrice = ticketData => {
  const price = useMemo(() => {
    const {
      ticket
    } = ticketData;
    if (ticket?.ticket_price > 0) {
      return `¥${(ticket.ticket_price / 100).toFixed(2)}`;
    }
    return '免费';
  }, [ticketData]);
  return price;
};
export default usePrice;